export default __webpack_public_path__ + "static/media/womanSit.7b89bee3.svg";